import EnumClass, { build } from '../EnumClass';
import data, { SubscriptionTypeId, SubscriptionTypeData } from './data';
import * as Translations from './translations';

export class SubscriptionType extends EnumClass<SubscriptionTypeId, SubscriptionTypeData> {
  public get getName() {
    return Translations.name[this.id];
  }

  public get getDescription() {
    return Translations.description[this.id];
  }
}

export const {
  list: SUBSCRIPTION_TYPES,
  getById: getSubscriptionTypeById,
  marshaller: SubscriptionTypeMarshaller,
} = build<SubscriptionTypeId, SubscriptionTypeData, SubscriptionType>('SubscriptionTypeEnum', data, SubscriptionType);
